var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1063.984,
    height: 611.502,
    viewBox: "0 0 1063.984 611.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector-bg",
    d: "M669.393,224.448,1063.984,0V611.5H0Z",
    fill: "#24c1cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBg);
export default __webpack_public_path__ + "static/media/option_bg.079d2595.svg";
export { ForwardRef as ReactComponent };